/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dnlLink[_ngcontent-%COMP%]{padding-right:10px;display:block}"];
export { styles as styles };
